module.exports = __webpack_public_path__ + "static/media/nicolas_paz.0b138920.jpg";